import { FC, memo } from 'react';
import { IncomingStatisticsV2 } from '../../components/IncomingStatisticsV2/IncomingStatisticsV2';
import { useIncomingStatisticsV2Screen } from '../../hooks/screens/useIncomingStatisticsV2Screen';

export const IncomingStatisticsV2Screen: FC = memo(() => {
  const props = useIncomingStatisticsV2Screen();

  return <IncomingStatisticsV2 {...props} />;
});

IncomingStatisticsV2Screen.displayName = 'IncomingStatisticsV2Screen';
